(function () {
    function initCollectionFooter(root) {

        root.querySelector("[data-mb-collection-description-toggle]").addEventListener("click", (e) => {
            const isExpanded = root.getAttribute("aria-expanded") === "true";
            root.setAttribute("aria-expanded", !isExpanded);
        })

    }

    function initAll(root) {
        root.querySelectorAll("[data-mb-collection-description]").forEach(initCollectionFooter);
    }

    document.addEventListener("DOMContentLoaded", () => initAll(document));
    document.addEventListener("shopify:section:load", (e) => initAll(e.target));
})();
